import dutchMessages from 'components/Languages/ra-language-dutch';
import _ from 'lodash';
import { StringMap, TranslationMessages } from 'react-admin';

const extendedDutchMessages = {
  ra: {
    action: {
      update_application: 'Update applicatie',
    },
    message: {
      auth_error: 'Er is een fout opgetreden bij het valideren van het authenticatietoken.',
      clear_array_input: 'Weet u zeker dat u de hele lijst wilt wissen?',
    },
    notification: {
      application_update_available:
        'Er is een nieuwe versie van de applicatie beschikbaar. Klik hier om de pagina te herladen.',
    },
    navigation: {
      clear_filters: 'Filters wissen',
      no_more_results: 'Geen resultaten meer',
      no_filtered_results: 'Geen gefilterde resultaten',
    },
  },
};
//@ts-ignore
export const nl: TranslationMessages = {
  ..._.merge<StringMap, StringMap>(dutchMessages, extendedDutchMessages),

  custom: {
    auth: {
      login: {
        title: 'Inloggen',
        subtitle: 'Voer uw e-mailadres en wachtwoord in',
        email: 'E-mail',
        password: 'Wachtwoord',
        submit: 'Inloggen',
        forgot_password: 'Wachtwoord vergeten?',
        error: 'Ongeldige inloggegevens',
      },
      forgot_password: {
        title: 'Wachtwoord vergeten',
        subtitle: 'Voer uw e-mailadres in om uw wachtwoord opnieuw in te stellen',
        email: 'E-mail',
        submit: 'Wachtwoord opnieuw instellen',
        back_to_login: 'Terug naar inloggen',
        error: 'Fout bij het verzenden van de instructies voor het opnieuw instellen van het wachtwoord',
        success: 'Instructies voor het opnieuw instellen van het wachtwoord zijn verzonden',
        failed: 'Fout bij het verzenden van de instructies voor het opnieuw instellen van het wachtwoord',
      },
      reset_password: {
        title: 'Wachtwoord opnieuw instellen',
        subtitle: 'Voer uw nieuwe wachtwoord in',
        password: 'Nieuw wachtwoord',
        confirm_password: 'Bevestig wachtwoord',
        submit: 'Wachtwoord opnieuw instellen',
        back_to_login: 'Terug naar inloggen',
        error: 'Fout bij het opnieuw instellen van het wachtwoord',
        success: 'Wachtwoord opnieuw instellen gelukt',
        failed: 'Fout bij het opnieuw instellen van het wachtwoord',
        passwords: {
          token: 'Ongeldig token',
          email: 'Email',
        },
        validation: {
          confirmed: 'Wachtwoorden komen niet overeen',
        },
      },
      verify_email: {
        title: 'Verify email',
        subtitle: 'Please enter the code sent to your email',
        code: 'Code',
        submit: 'Verify email',
        back_to_login: 'Back to login',
        error: 'Invalid code',
      },
    },
    actions: {
      add: '%{Name} toevoegen',
      copy: 'Kopieer naar klembord',
      preview: 'Voorbeeld',
      download: 'Download',
      edit: '%{Name} bijwerken',
      request: 'Aanvragen',
      show: 'Toon %{name}',
    },
    labels: {
      actions: 'Acties',
      compatible: 'Compatibel',
      icon: 'Icoon',
      options: 'Opties',
      required: 'Verplicht',
      universal: 'Universeel',
      used_by: 'Gebruikt door',
    },
    notification: {
      error: {
        not_found: '%{item} niet gevonden',
      },
      success: '%{action} geslaagd',
      download: '%{item} gedownload',
      download_started: 'Download van %{item} gestart',
    },
  },

  message: {
    add_title: '%{resource} aan %{target} toevoegen.',
  },
  validation: {
    error: 'Validatiefout',
    exists: 'Item bestaat niet',
    required: 'Vereist',
    unique: 'Item bestaat al',
  },
  resources: {
    activity_logs: {
      fields: {
        created_at: 'Activiteit op',
      },
    },
    app_collection_defaults: {
      fields: {
        app_collection_id: 'Collectie',
        created_at: 'Aanmaakdatum',
      },
    },
    app_collection_subscriptions: {
      name: 'Abonnement |||| Abonnementen',
      fields: {
        app_collection_id: 'Collectie',
        length: 'Duur',
        my_tover_access: 'Toegang tot My Tover',
        start_date: 'Startdatum',
        start_now: 'Nu starten',
        invoice_number: 'Factuurnummer',
      },
    },
    app_collection_trials: {
      name: 'Proefcollectie |||| Proefcollecties',
      forcedCaseName: 'Proefcollectie |||| Proefcollecties',
      fields: {
        active: 'Actief',
        app_collection_id: 'Collectie',
        configuration_id: 'Configuratie-ID',
        created_at: 'Aanmaakdatum',
        length: 'Duur',
        valid_from: 'Geldig vanaf',
        valid_until: 'Geldig tot',
      },
    },
    app_collections: {
      name: 'Collectie |||| Collecties',
    },
    app_trials: {
      name: 'Proefapp |||| Proefapps',
      fields: {
        created_at: 'Aanmaakdatum',
        length: 'Duur',
        translated_name: 'Naam',
      },
    },

    apps: {
      name: 'App |||| Apps',
      forcedCaseName: 'App |||| Apps',
      fields: {
        'app_ids': 'Apps',
        'icon.src': 'Icoon',
        'cognitive': 'Spelniveau',
        'created_at': 'Aanmaakdatum',
        'flavour_ids': 'Doelgroep(en)',
        'designation': {
          id: 'Toewijzing',
        },
        'designation_ids': 'Toewijzing(en)',
        'lab_enabled': 'Tover Lab ingeschakeld',
        'enabled': 'Ingeschakeld',
        'flavour_id': 'Doelgroep',
        'icon': 'Icoon',
        'name': 'Gamecode',
        'product_id': 'Product ID',
        'translated_name': 'Naam',
      },
    },
    collections: {
      name: 'Collectie |||| Collecties',
      forcedCaseName: 'Collectie |||| Collecties',
      fields: {
        app_id: 'App',
        app_ids: 'Apps',
        apps_count: 'Apps',
        available_as_subscription: 'Verkrijgbaar als abonnement?',
        designation_ids: 'Toewijzing(en)',
        flavour_id: 'Doelgroep',
        name: 'Naam',
      },
      tabs: {
        general: 'General',
        apps: 'Apps',
      },
    },
    commands: {
      fields: {
        status: 'Status',
      },
      status: {
        active: 'Actief',
        deleted: 'Verwijderd',
        deleted_at: 'Verwijderd op %{date}',
      },
      restore: {
        action: 'Herstellen',
        success: 'Commando "%{name}" is hersteld',
        error: 'Commando "%{name}" kon niet worden hersteld. %{error}',
        deleted_notice: 'Dit commando is op %{date} verwijderd. Herstel het om het weer beschikbaar te maken.',
      },
      create: {
        created: 'Commando "%{name}" is aangemaakt',
        created_with_parameters: 'Commando "%{name}" is aangemaakt met %{count} parameter(s)',
        parameters_partially_saved:
          'Commando "%{name}" is aangemaakt, maar niet alle parameters konden worden opgeslagen. Opgeslagen: %{saved}. Niet opgeslagen: %{failed}. Voeg de ontbrekende parameters hier toe.',
        none: 'geen',
        name_taken_by_deleted_title: 'Deze naam hoort bij een verwijderd commando',
        name_taken_by_deleted:
          'Er bestaat nog een verwijderd commando met de naam "%{name}". Herstel dat commando in plaats van een nieuw commando aan te maken, of kies een andere naam.',
      },
      edit: {
        save_failed: 'Het commando kon niet worden opgeslagen',
      },
      parameters: {
        title: 'Parameters',
        add: 'Parameter toevoegen',
        empty: 'Geen parameters ingesteld',
        draft_hint:
          'Parameters worden opgeslagen zodra het commando is aangemaakt, in de volgorde die hier wordt weergegeven.',
        move_up: 'Omhoog',
        move_down: 'Omlaag',
        duplicate_name: 'Er bestaat al een parameter met de naam "%{name}" voor dit commando',
        fields: {
          name: 'Naam',
          display_name: 'Weergavenaam',
          data_type: 'Datatype',
          ui_component: 'UI-component',
          required: 'Verplicht',
          order: 'Volgorde',
          actions: 'Acties',
        },
      },
    },
    configurations: {
      fields: {
        id: 'Configuratie-ID',
        serial: 'Serienummer',
      },
    },
    countries: {
      name: 'Land |||| Landen',
      fields: {
        active: 'Toon alleen actief',
        name: 'Naam',
      },
      tabs: {
        general: 'Algemeen',
        regions: "Regio's",
      },
    },
    designations: {
      name: 'Toewijzing |||| Toewijzingen',
      forcedCaseName: 'Toewijzing |||| Toewijzingen',
      fields: {
        app_collection_ids: 'Collecties',
        app_ids: 'Apps',
        default: 'Standaard',
        designation_ids: 'Toewijzingen',
        name: 'Naam',
      },
      tabs: {
        apps: 'Apps',
        collections: 'Collecties',
        general: 'General',
      },
    },
    diagnostics: {
      fields: {
        attachments: 'Bijlagen',
        created_at: 'Aanmaakdatum',
        data: {
          script: 'Naam',
        },
        identifier: 'Aanduiding',
        type: 'Type',
      },
    },
    flavours: {
      name: 'Doelgroep |||| Doelgroepen',
      forcedCaseName: 'Doelgroep |||| Doelgroepen',
      fields: {
        app_collection_id: 'Collectie',
        color: 'Kleur',
        default_app_collection_id: 'Standaard collectie',
        default_app_collections: 'Standaard collecties',
        locale_id: 'Taal',
        name: 'Naam',
        serial: 'Serienummer',
      },
    },
    hardware: {
      fields: {
        name: 'Naam',
        flavour_id: 'Standaarddoelgroep',
      },
      section: {
        general: 'Hardware',
        hardware_revisions: 'Revisies',
        software_components: 'Softwarecomponenten',
      },
    },
    hardware_revisions: {
      name: 'Hardwarerevisie |||| Hardwarerevisies',
      fields: {
        update_channel_id: 'Standaard updatekanaal',
        update_channel_ids: 'Updatekanalen',
      },
    },
    locales: {
      // https://learn.microsoft.com/nl-nl/partner-center/developer/partner-center-supported-languages-and-locales
      name: 'Cultuur |||| Culturen',
      forcedCaseName: 'Cultuur |||| Culturen',
      fields: {
        description: 'Beschrijving',
        language_ids: 'Extra talen',
        name: 'Naam',
      },
    },
    partners: {
      fields: {
        sales_force_id: 'Salesforce ID',
        client_number: 'Partner ID',
        service_person: 'Contactpersoon',
        service_phone_number: 'Contact telefoonnummer',
        name: 'Naam',
        sales_email: 'Sales e-mailadres',
        service_email: 'Service e-mailadres',
      },
      section: {
        general: 'Algemeen',
        partner_groups: 'Partnergroepen',
      },
      name: 'Partner |||| Partners',
    },
    partner_groups: {
      name: 'Partnergroep |||| Partnergroepen',
      forcedCaseName: 'Partnergroep |||| Partnergroepen',
      empty: 'Deze partner behoort tot geen enkele partnergroep.',
      fields: {
        name: 'Naam',
        account_manager: 'Accountmanager',
        service_email: 'Service e-mailadres',
        country_id: 'Land',
        region_id: 'Regio',
        countries: 'Land',
      },
      message: {
        create_content: 'Geef een naam op voor de nieuw aangemaakte regio voor deze partnergroep.',
        add_content: 'Voeg een nieuwe regio toe voor deze partnergroep.',
        update_content: 'Werk de gegevens van deze partnergroep bij.',
      },
    },
    playlists: {
      fields: {
        icon: 'Icoon',
      },
    },
    regions: {
      name: "Regio |||| Regio's",
      fields: {
        name: 'Naam',
      },
      empty: "Dit land heeft geen regio's.",
    },
    software_components: {
      name: 'Softwarecomponent |||| Softwarecomponenten',
      fields: {
        name: 'Naam',
        hardware_ids: 'Hardware',
        path: 'Pad',
        build_project_name: 'Build-projectnaam',
        required_hardware_ids: 'Verplichte hardware',
        software_version_id: 'Versie',
      },
    },
    software_releases: {
      name: 'Software-uitgave |||| Software-uitgaven',
      create: {
        title: 'Uitgave aanmaken',
        clone_read_only: 'kloon: alleen-lezen',
        software_components: 'Softwarecomponenten',
      },
      edit: {
        components_error:
          'De softwarecomponenten voor deze hardware konden niet worden geladen. Probeer het opnieuw voordat je opslaat.',
        no_components: 'Deze hardware heeft geen softwarecomponenten.',
        save_failed: 'De uitgave kon niet worden opgeslagen',
      },
      fields: {
        custom: 'Aangepast',
        hardware_id: 'Hardware',
        hardware_revision_id: 'Hardwarerevisie',
        name: 'Naam',
        software_components: 'Softwarecomponenten',
        software_version_id: 'Versie',
      },
    },
    subscriptions: {
      name: 'Abonnement |||| Abonnementen',
      fields: {
        unlock_key: 'Ontgrendelcode',
      },
    },
    software_versions: {
      name: 'Softwareversie |||| Softwareversies',
      fields: {
        version: 'Versie',
        hardware_ids: 'Hardware',
        software_component_id: 'Softwarecomponent',
        update_channel_ids: 'Updatekanalen',
      },
    },
    units: {
      name: 'Tovertafel |||| Tovertafels',
      forcedCaseName: 'Tovertafel |||| Tovertafels',
      list: {
        export_csv: 'Exporteer CSV',
      },
      notifications: {
        designation_not_set: 'Toewijzing is niet ingesteld! Stel deze eerst in.',
      },
      uses_staging_api:
        'Deze Tovertafel is ingesteld op de Staging API. Wijzigingen die je hier maakt, werken pas op de Tovertafel zodra deze is teruggezet.',
      fields: {
        configuration_key: 'Configuratiesleutel',
        collections: 'Collecties',
        country_id: 'Land',
        designation_id: 'Toewijzing',
        developer_options: {
          allow_terminal: 'Terminal toestaan',
          api_status: 'API-status',
          no_getconfig: 'Get Config uitschakelen',
          debug_panel: 'Debug-paneel',
          design_tools: 'Ontwerptools',
          diagnostics: 'Diagnostiek',
          is_lte_enabled: 'LTE ingeschakeld',
          staging_api: 'Gebruik Staging API',
          boot_next_recovery: 'Herstart naar herstelmodus',
          mqtt_enabled: 'MQTT ingeschakeld',
        },
        firmware_version: 'Firmwareversie',
        hardware_id: 'Hardware',
        hostname: 'Hostnaam',
        install_date: 'Installatiedatum',
        language_ids: 'Extra talen',
        last_edit: 'Laatst bewerkt',
        last_online: 'Laatst online',
        locale_id: 'Taal',
        mobile_network: {
          alert_threshold: 'Alarmgrens',
          bandwidth_usage: 'Bandbreedtegebruik',
          bandwidth_limit: 'Bandbreedtelimiet',
          is_lte_enabled: 'LTE ingeschakeld',
          next_reset_time: 'Volgende databundel reset tijd',
          provider: 'Aanbieder',
          sim_id: 'Simkaart ID',
          state: 'Status',
          states: {
            unavailable: 'Onbeschikbaar',
            available: 'Beschikbaar',
            critical: 'Kritiek',
          },
        },
        software_versions: {
          tover_tafel: 'Softwareversie',
          tover_firmware: 'Firmwareversie',
          tover_up: 'ToverUp',
          tover_tele: 'Telekinesis',
          tover_sysup: 'ToverSysup',
          tover_comms: 'ToverComms',
          tover_conjure: 'FAT',
        },
        manifest: {
          current_release_name: 'Huidige uitgave',
          new_release_name: 'Nieuwe uitgave',
          update_channel: 'Updatekanaal',
          update_state: 'Updatestatus',
          last_update_check_at: 'Laatste updatecontrole',
          last_update_received_at: 'Laatste update ontvangen',
        },
        causer_id: 'Uitgevoerd door',
        partner_group_id: 'Partnergroep',
        partner_id: 'Partner',
        real_ip: 'Laatste publieke IP (WAN)',
        serial: 'Serienummer',
        serial_number: 'Serienummer',
        show_uptime: 'Cumulatieve bedrijfstijd weergeven',
        software_version: 'Softwareversie',
        studio_access: 'Tover Lab ingeschakeld',
        update_channel_id: 'Updatekanaal',
      },
      section: {
        access_control: 'Toegangsbeheer',
        app_collections: 'Collecties',
        details: 'Systeemdetails',
        general: 'Algemeen',
        history: 'Geschiedenis',
        legal: 'Juridisch',
        localization: 'Lokalisatie',
        partner: 'Partner',
        preferences: 'Voorkeuren',
        purchased_apps: 'Gekochte apps',
        subscriptions: 'Abonnementen',
        trial_app_collections: 'Proefapp collecties',
        trial_apps: 'Proefapps',
        simcard_info: 'Simkaartinformatie',
        mobile_permissions: 'Rechten',
        simcard_data: 'Dataverbruik',
        software_update: 'Software-update',
      },
      updater: {
        never_reported: 'Deze Tovertafel heeft nog geen updatestatus gemeld.',
        no_state: 'Onbekend',
        no_components: 'Geen softwarecomponenten gemeld.',
        fields: {
          component: 'Component',
          version: 'Geïnstalleerde versie',
          updating_to: 'Wordt bijgewerkt naar',
          update_state: 'Updatestatus',
        },
      },
      tabs: {
        info: 'Informatie',
        apps: 'Apps',
        configuration: 'Configuratie',
        commands: "Commando's",
        developer_options: 'Ontwikkelaarsopties',
        diagnostics: 'Diagnostiek',
        mobile_network: 'Mobiel netwerk',
        activity_log: 'Activiteitenlog',
        simcard: 'Simkaart',
        reports: 'Rapporten',
      },
      show: {
        links: {
          rsh: 'RSH',
          terminal: 'Terminal',
          config: 'Configuratie',
          sim: 'Simkaart',
          refresh_config: 'Ververs configuratie',
          fix_missing_sim: 'Ontbrekende simkaart oplossen',
          fat: 'FAT',
        },
        vpn: {
          method_label: 'VPN-methode',
          method_mqtt: 'MQTT',
          method_direct: 'Directe VPN',
          method_switch_label: 'MQTT-VPN-methode gebruiken',
          mqtt_unsupported_tt1: 'MQTT wordt niet ondersteund op TT1-units.',
          mqtt_disabled: 'MQTT is uitgeschakeld voor deze unit.',
          mqtt_no_ssh_key: 'Geen geldige SSH-sleutel geregistreerd voor deze unit.',
          direct_no_permission: 'Je hebt geen rechten om een directe VPN-verbinding te openen.',
          no_method_available: 'Er is geen VPN-verbindingsmethode beschikbaar.',
          connect: 'Verbinden met VPN',
          status: 'Status',
          disconnected: 'niet verbonden',
          ip_address: 'VPN-IP',
          copy_command: 'SSH-commando kopiëren',
          command_copied: 'SSH-commando gekopieerd naar klembord',
          connect_failed: 'Kon de VPN-verbinding niet openen',
          disconnect_failed: 'Kon de VPN-verbinding niet sluiten',
          switch_method_failed: 'Kon niet wisselen van VPN-methode',
        },
      },
      count: '%{smart_count} Tovertafel |||| %{smart_count} Tovertafels',
      helpers: {
        hostname: 'Hostnaam wordt automatisch gegenereerd voor Pixies',
        real_ip:
          'Het laatste publieke internetadres (WAN) waarmee deze Tovertafel verbinding maakte met de API. Dit is niet het VPN-IP.',
      },
      reports: {
        eventlog: 'Event log',
        game_played: 'Game played',
        start_date: 'Startdatum',
        end_date: 'Einddatum',
        period: 'Report periode',
        download: {
          bulkButton: 'Rapporten downloaden',
          eventlog: 'Event log downloaden',
          game_played: 'Game played downloaden',
        },
        types: {
          eventlog: 'Event log',
          game_played: 'Game played',
        },
      },
      bulk_assign: {
        button: 'Eigenschap toewijzen',
        dialog_title: 'Eigenschap in bulk toewijzen aan tovertafels',
        field_label: 'Te wijzigen eigenschap',
        field_placeholder: 'Selecteer een eigenschap...',
        value_label: 'Nieuwe waarde',
        value_placeholder: 'Selecteer een waarde...',
        units_list_label: 'Geselecteerde tovertafels (%{count})',
        confirm_button: 'Toewijzen aan %{count} tovertafel(s)',
        cancel_button: 'Annuleren',
        close_button: 'Sluiten',
        warning_mixed_hardware:
          'Waarschuwing: de geselecteerde tovertafels hebben verschillende hardwarerevisies. Het updatekanaal is mogelijk niet compatibel met alle tovertafels. Incompatibele tovertafels worden overgeslagen.',
        success_all: '%{count} tovertafel(s) succesvol bijgewerkt',
        success_partial: '%{successCount} tovertafel(s) bijgewerkt, %{failureCount} mislukt',
        error_generic: 'Bulk toewijzen mislukt',
        results_success_heading: 'Succesvol toegewezen (%{count})',
        results_failure_heading: 'Mislukt (%{count})',
        fields: {
          designation_id: 'Toewijzing',
          locale_id: 'Taal',
          update_channel_id: 'Updatekanaal',
          partner_id: 'Partner',
        },
      },
      batch_assign_channel: {
        button: 'Eenheden toewijzen aan kanaal',
        dialog_title: 'Eenheden in bulk toewijzen aan updatekanaal',
        channel_label: 'Updatekanaal',
        tab_serials: 'Serienummers invoeren',
        tab_csv: 'CSV uploaden',
        serials_label: 'Serienummers',
        serials_placeholder: 'Één serienummer per regel…',
        file_label: 'CSV-bestand kiezen',
        file_helper: 'Upload een .csv-bestand met een kolom met serienummers',
        submit_button: 'Toewijzen',
        cancel_button: 'Annuleren',
        close_button: 'Sluiten',
        success_all: '%{count} eenheid/eenheden succesvol toegewezen aan kanaal',
        error_generic: 'Bulk toewijzen aan kanaal mislukt',
        results_summary:
          '%{updated} bijgewerkt, %{skipped} overgeslagen, %{not_found} niet gevonden (totaal: %{total})',
        results_updated_heading: 'Bijgewerkt (%{count})',
        results_skipped_heading: 'Overgeslagen (%{count})',
        results_not_found_heading: 'Niet gevonden (%{count})',
        warning_mixed_hardware:
          'De geselecteerde eenheden hebben verschillende hardware-revisies. Alleen eenheden met dezelfde hardware-revisie kunnen in bulk aan een kanaal worden toegewezen. Pas uw selectie aan.',
        info_multiple_source_channels:
          'De geselecteerde eenheden zijn momenteel op verschillende updatekanalen. U kunt optioneel filteren van welke bronkanalen u wilt verplaatsen, of alles geselecteerd laten om van alle kanalen te verplaatsen.',
        source_channel_label: 'Verplaatsen van kanaal(en)',
        source_channel_all: 'Alle kanalen',
        source_channel_unassigned: 'Niet toegewezen',
        source_channel_filtered_count: '%{count} van %{total} serienummers worden ingediend',
        skip_reason_no_configuration_found: 'Geen configuratie gevonden',
        skip_reason_hardware_revision_mismatch: 'Hardware-revisie komt niet overeen',
        skip_reason_hardware_revision_mismatch_details:
          'Hardware-revisie komt niet overeen (%{hardware} / %{hardware_revision})',
      },
    },
    update_channels: {
      name: 'Updatekanaal |||| Updatekanalen',
      fields: {
        name: 'Naam',
        hardware_id: 'Hardware',
        release_now: 'Nu uitgeven',
        released_at: 'Uitgavetijd',
        software_release_id: 'Software-uitgave',
        short_name: 'Verkorte naam',
        hardware_revision: {
          name: 'Revisie',
        },
        units_count: 'Tovertafels',
        current_releases: 'Huidige uitgave',
      },
      helpers: {
        name_unique: 'Moet uniek zijn binnen alle updatekanalen.',
      },
      list: {
        not_released: 'Nog niet uitgegeven',
        revision_count: '%{smart_count} revisie |||| %{smart_count} revisies',
      },
      section: {
        general: 'Algemeen',
        hardware_revisions: 'Hardware & revisies',
        current_release: 'Huidige uitgave',
        release_history: 'Uitgavegeschiedenis',
        units: 'Tovertafels',
      },
      release_history: {
        select_prompt: 'Selecteer een hardware of revisie om de uitgavegeschiedenis te zien',
      },
      units: {
        empty: 'Er zijn geen tovertafels toegewezen aan dit updatekanaal.',
        search_placeholder: 'Tovertafels zoeken…',
        assign_button: 'Toewijzen aan dit kanaal',
        detach_button: 'Verplaatsen naar een ander kanaal',
        detach_confirm_title: 'Tovertafels verplaatsen naar een ander kanaal',
        detach_confirm_body: 'Selecteer het doelkanaal voor %{count} tovertafel(s):',
        detach_confirm_button: 'Verplaatsen',
        detach_cancel_button: 'Annuleren',
        detach_close_button: 'Sluiten',
        detach_target_channel_label: 'Doelkanaal',
        detach_success_all: '%{count} tovertafel(s) verplaatst naar %{channel}',
        detach_success_partial: '%{successCount} tovertafel(s) verplaatst naar %{channel}, %{failureCount} mislukt',
        detach_error: 'Verplaatsen mislukt',
        results_success_heading: 'Succesvol verplaatst (%{count})',
        results_failure_heading: 'Mislukt (%{count})',
      },
      csv_import: {
        button: 'Tovertafels importeren via CSV',
        dialog_title: 'Tovertafels importeren via CSV',
        file_label: 'CSV-bestand (serienummers, één per regel)',
        file_helper: 'Upload een .csv-bestand met één serienummer per regel',
        submit_button: 'Importeren',
        cancel_button: 'Annuleren',
        close_button: 'Sluiten',
        success: '%{count} tovertafel(s) succesvol geïmporteerd',
        success_partial: '%{successCount} tovertafel(s) geïmporteerd, %{failureCount} mislukt',
        error: 'Importeren mislukt',
        results_success_heading: 'Geïmporteerd (%{count})',
        results_failure_heading: 'Mislukt (%{count})',
      },
    },
    dashboard: {
      name: 'Dashboard',
      missing_units_from_elastic: 'Ontbrekende tovertafels in ES',
      add_missing_units: 'Ontbrekende tovertafels toevoegen',
      fields: {},
    },
    channel_releases: {
      name: 'Uitgave |||| Uitgaven',
      fields: {
        created_at: 'Aanmaakdatum',
        hardware_id: 'Hardware',
        released_at: 'Uitgavetijd',
        release_now: 'Nu uitgeven',
        software_release_id: 'Software-uitgave',
        update_channel_id: 'Updatekanaal',
      },
      forms: {
        edit: {
          header: 'U kunt hier alleen de uitgavedatum bewerken.',
        },
        create: {
          header: 'Selecteer de software-uitgave voor dit kanaal en stel de uitgavedatum in.',
        },
      },
      action: {
        released: 'Uitgegeven',
      },
    },
    users: {
      name: 'Gebruiker |||| Gebruikers',
      fields: {
        name: 'Naam',
        email: 'Email',
        roles: 'Rollen',
      },
    },
    vpn: {
      name: 'VPN-verbinding |||| VPN-verbindingen',
      fields: {
        id: 'ID',
        ip_address: 'IP-adres',
        created_at: 'Gestart',
      },
    },
    permissions: {
      name: 'Rechten |||| Rechten',
      fields: {
        name: 'Naam',
      },
      values: {
        'add_units': 'Tovertafels toevoegen',
        'dev_options': 'Ontwikkelaarsopties',
        'filter': 'Filter',
        'manage_apps': 'Apps beheren',
        'manage_builds': 'Builds beheren',
        'manage_collections': 'Collecties beheren',
        'manage_designations': 'Toewijzingen beheren',
        'manage_flavours': 'Aspecten beheren',
        'manage_locales': 'Talen beheren',
        'manage_location_contact': 'Locatiecontact beheren',
        'manage_units': 'Tovertafels beheren',
        'manage_userroles': 'Gebruikersrollen beheren',
        'manage_users': 'Gebruikers beheren',
        'mytover invite admin': 'My Tover uitnodiging beheren - admin',
        'mytover invite user': 'My Tover uitnodiging beheren - gebruiker',
        'offer_trial_apps': 'Proefapps aanbieden',
        'perform_rollback': 'Rollback uitvoeren',
        'remove_units': 'Tovertafels verwijderen',
        'report': 'Rapport',
        'reset_units': 'Tovertafels resetten',
        'view_dashboard': 'Dashboard bekijken',
        'use_toverview': 'ToverView gebruiken',
      },
    },
  },
};
